import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { PackageSearch, LayoutDashboard, LogOut, User, ChevronRight, Heart } from "lucide-react";

export default function Account() {
  const { user, checked, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (checked && !user) navigate("/login", { state: { next: "/account" } });
  }, [checked, user, navigate]);

  if (!user) return (<div className="App"><Navbar /><div className="py-24 text-center text-sugar-ink2">Loading…</div></div>);

  const rows = [
    { label: "My orders", icon: PackageSearch, onClick: () => navigate("/track"), testid: "account-orders" },
    ...(user.role === "admin" ? [{ label: "Bakery dashboard", icon: LayoutDashboard, onClick: () => navigate("/admin"), testid: "account-admin" }] : []),
  ];

  return (
    <div className="App bg-sugar-bg"><Navbar />
      <div className="px-5 py-8">
        <div className="flex items-center gap-4">
          <span className="grid h-16 w-16 place-items-center rounded-full bg-sugar-ink text-sugar-bg">
            <User size={28} />
          </span>
          <div>
            <h1 className="font-display text-2xl font-semibold text-sugar-ink">{user.name}</h1>
            <p className="text-sm text-sugar-ink2">{user.email}</p>
            {user.role === "admin" && <span className="mt-1 inline-block rounded-full bg-sugar-blush px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-sugar-wine">Owner</span>}
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-sm border border-sugar-border bg-sugar-card">
          {rows.map((r) => (
            <button key={r.label} data-testid={r.testid} onClick={r.onClick} className="flex w-full items-center gap-3 border-b border-sugar-border px-5 py-4 text-left last:border-0 hover:bg-sugar-bg2">
              <r.icon size={19} className="text-sugar-rose" />
              <span className="flex-1 font-semibold text-sugar-ink">{r.label}</span>
              <ChevronRight size={17} className="text-sugar-muted" />
            </button>
          ))}
        </div>

        <Button data-testid="account-order-cta" onClick={() => navigate("/order")} className="mt-6 w-full rounded-sm bg-sugar-ink py-6 text-xs font-bold uppercase tracking-[0.18em] text-sugar-bg hover:bg-sugar-pinkhover">
          Start a new order
        </Button>

        <Button data-testid="account-logout" variant="outline" onClick={() => { logout(); navigate("/"); }} className="mt-3 w-full rounded-sm border-sugar-border py-6 text-xs font-bold uppercase tracking-[0.18em] text-sugar-ink2 hover:bg-sugar-blush">
          <LogOut size={16} className="mr-2" /> Log out
        </Button>

        <p className="mt-10 flex items-center justify-center gap-1.5 text-center text-xs text-sugar-muted">
          Made with <Heart size={11} className="text-sugar-rose" fill="#C08A8A" /> in British Columbia
        </p>
      </div>
    </div>
  );
}
